<template>
  <div class="detail">
    <el-card shadow="never">
      <div slot="header">
        <span class="title">优惠券信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div style="width: 500px;">
        <el-form ref="infoForm" :model="infoForm" :rules="infoRules" label-width="120px">
          <el-form-item label="优惠券名称" prop="couponName">
            <el-input v-model="infoForm.couponName" :disabled="isDisabled" placeholder="请输入优惠券名称" />
          </el-form-item>
          <el-form-item label="优惠券类型" prop="type">
            <el-select v-model="infoForm.type" :disabled="isDisabled" style="width: 200px;" placeholder="请选择优惠券类型">
              <el-option v-for="item in allCoupon" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </el-form-item>
          <template v-if="infoForm.type===1">
            <el-form-item label="优惠券面额" prop="amount">
              <div class="d-flex">
                <el-input v-model="infoForm.amount" :disabled="isDisabled" placeholder="请输入优惠券面额" />
                <div style="padding-left: 10px;">元</div>
              </div>
            </el-form-item>
          </template>
          <template v-if="infoForm.type===2">
            <el-form-item label="优惠券折扣" prop="discount">
              <div class="d-flex">
                <el-input v-model="infoForm.discount" :disabled="isDisabled" placeholder="请输入优惠券折扣" />
                <div style="padding-left: 10px;">%</div>
              </div>
            </el-form-item>
            <el-form-item label="折扣抵扣上限" prop="limitAmount">
              <div class="d-flex">
                <el-input v-model="infoForm.limitAmount" :disabled="isDisabled" placeholder="请输入折扣抵扣上限" />
                <div style="padding-left: 10px;">元</div>
              </div>
            </el-form-item>
          </template>
          <el-form-item label="优惠券数量" prop="couponNum">
            <el-input v-model="infoForm.couponNum" :disabled="isDisabled" placeholder="请输入优惠券数量" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">承担方设置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="undertakerForm" :model="undertakerForm" :rules="undertakerRules" label-width="120px">
          <template v-for="(row,index) in undertakerForm.underArray">
            <el-form-item :key="index" :label="'承担方'+numberfilter(index+1)" prop="undertaker">
              <div class="d-flex">
                <!-- <el-select v-model="row.id" v-selectLoadMore="selectLoadMore" :disabled="isDisabled" style="width: 200px;" placeholder="请选择活动承担机构">
                  <el-option v-for="item in allUndertaker" :key="item.id" :label="item.name" :value="item.id" />
                </el-select> -->
                <el-input v-model="row.name" class="w30" :disabled="isDisabled" />
                <div class="ml-20">承担比例</div>
                <el-input v-model="row.percent" :disabled="isDisabled" type="number" class="ml-20" style="width: 100px;" />
                <div class="ml-20">%</div>
                <i v-if="!isDisabled" class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addUndertaker(index)" />
                <i v-if="!isDisabled" v-show="index!==0" class="icon-jia ml-20 el-icon-remove-outline" @click="delUndertaker(index)" />
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">使用限制</span>
      </div>
      <div style="width: 550px;">
        <el-form ref="useLimitForm" :model="useLimitForm" :rules="useLimitRules" label-width="120px">
          <el-form-item label="抵扣费用类型" prop="deductionType">
            <el-radio-group v-model="useLimitForm.deductionType" :disabled="isDisabled">
              <el-radio v-for="(item, index) in allDeductionType" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="this.totalFormItem" prop="amount">
            <div class="d-flex amount">
              <div>满</div>
              <el-input v-model="useLimitForm.amount" :disabled="isDisabled" placeholder="请输入金额" />
              <div>元可用</div>
            </div>
          </el-form-item>
          <el-form-item label="使用时间" prop="useTime">
            <el-radio-group v-model="useLimitForm.useTime" :disabled="isDisabled">
              <el-radio :label="1">相对时间</el-radio>
              <el-radio :label="2">绝对时间</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="useLimitForm.useTime===1">
            <el-form-item label="领取后" prop="relativeTime">
              <div class="d-flex amount">
                <el-input v-model="useLimitForm.relativeTime" :disabled="isDisabled" placeholder="请输入相对时间" />
                <div>天</div>
              </div>
            </el-form-item>
          </template>
          <template v-if="useLimitForm.useTime===2">
            <el-form-item label="使用期限" prop="useDate">
              <el-date-picker v-model="useLimitForm.useDate" :disabled="isDisabled" type="datetimerange" range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>
          </template>
          <el-form-item label="优惠券使用说明" prop="useExplain">
            <el-input v-model="useLimitForm.useExplain" :disabled="isDisabled" type="textarea" :rows="4" placeholder="请输入优惠券使用说明" />
          </el-form-item>
          <el-form-item label="可用电站" prop="partakeStation">
            <el-radio-group v-model="useLimitForm.partakeStation" :disabled="isDisabled">
              <el-radio :label="-1">全部电站</el-radio>
              <el-radio :label="1">选择运营商</el-radio>
              <el-radio :label="2">选择电站</el-radio>
            </el-radio-group>
            <!-- 详情时展示选的可用电站 -->
            <div v-if="isDisabled">
              <el-input v-show="useLimitForm.partakeStation!==-1" v-model="stationName" :disabled="isDisabled" type="textarea" :rows="4" />
            </div>
            <!-- 选择运营商 -->
            <div v-show="useLimitForm.partakeStation===1 && !isDisabled" class="border">
              <el-input v-model="filterOperatorText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="useLimitForm.partakeStation===2 && !isDisabled" class="border">
              <el-input v-model="filterStationText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { numberfilter } from '@/utils/tool'
export default {
  data() {
    return {
      isDisabled: false, // 是否禁用 详情true，新增false
      filterOperatorText: '', // 运营商过滤
      filterStationText: '', // 电站过滤
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      // 所有的优惠券类型
      allCoupon: [
        {
          id: 1,
          label: '现金券'
        },
        {
          id: 2,
          label: '折扣券'
        }
      ],
      infoForm: {
        couponName: '', // 优惠券名称
        type: '', // 优惠券类型
        discount: '', // 优惠券折扣
        limitAmount: '', // 折扣抵扣上限
        amount: '', // 优惠券面额
        couponNum: ''// 优惠券数量
      },
      infoRules: {
        couponName: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择优惠券类型', trigger: 'change' }
        ],
        discount: [
          { required: true, message: '请输入优惠券折扣', trigger: 'blur' }
        ],
        limitAmount: [
          { required: true, message: '请输入折扣抵扣上限', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入优惠券面额', trigger: 'blur' }
        ],
        couponNum: [
          { required: true, message: '请输入优惠券数量', trigger: 'blur' }
        ]
      },
      // 所有的活动承担机构
      allUndertaker: [],
      undertakerForm: {
        underArray: [
          {
            id: '', // 承担方
            index: '',
            name: '', // 承担方的label
            percent: ''// 承担比例
          }
        ]
      },
      undertakerRules: {
        undertaker: { required: true, trigger: 'change', validator: (undertakerRules, value, cb) => {
          if (this.rulesUndertakerRule) {
            return cb(new Error(this.rulesUndertakerRule))
          }
          return cb()
        } }
      },
      // 所有的抵扣费用类型
      allDeductionType: [ {
          id: 1,
          label: '服务费'
        }, {
          id: 2,
          label: '电费'
        },
                {
          id: 3,
          label: '总费用'
        }
      ],
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      useLimitForm: {
        deductionType: 3, // 抵扣费用类型
        amount: '', // 服务费-电费-总费用金额
        useTime: 1, // 使用时间
        relativeTime: '', // 领取后
        useDate: [], // 使用期限
        useExplain: '', // 优惠券使用说明
        partakeStation: -1, // 可用电站
        operator: [], // 选择运营商的值
        station: []// 选择电站的值
      },
      stationName: '', // 详情时可用电站的名字展示
      useLimitRules: {
        deductionType: [
          { required: true, message: '请选择抵扣费用类型', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ],
        useTime: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        relativeTime: [
          { required: true, message: '请输入相对时间', trigger: 'blur' }
        ],
        useDate: [
          { required: true, message: '请选择使用期限', trigger: 'blur' }
        ],
        useExplain: [
          { required: true, message: '请输入优惠券使用说明', trigger: 'blur' }
        ],
        partakeStation: [
          { required: true, message: '请选择可用电站', trigger: 'change' }
        ]
      },
      pageNo: 1,
      pageSize: 10
    }
  },
  computed: {
    totalFormItem() {
      const id = this.useLimitForm.deductionType
      const item = this.allDeductionType.find(item => { return item.id === id })
      return item.label
    },
    // 承担方设置表单的动态校验
    rulesUndertakerRule() {
      const dataArray = this.undertakerForm.underArray
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.id === '' && !currentObj.id.length) {
          return '请选择承担方'
        }
        if (!currentObj.percent && !currentObj.percent.length) {
          return '请输入承担比例'
        }
      }
      return ''
    }
  },
  watch: {
    filterOperatorText(val) {
      this.$refs.treeOperator.filter(val)
    },
    filterStationText(val) {
      this.$refs.treeStation.filter(val)
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.$route.query.isDisabled)
      // 获取当前是新增还是详情
      this.isDisabled = !!Number(this.$route.query.isDisabled)
      // 如果是详情 则直接加载传过来的数据
      this.isDisabled && this.getDetail(this.$route.query.data)
      // 加载树数据
      this.loadTree()
      // 加载承担方数据
      this.loadUndertaker()
    })
  },
  methods: {
    // 加载详情数据
    getDetail(data) {
      const couponData = JSON.parse(data.couponData)
      const infoObj = {
        couponName: data.couponName,
        type: data.type,
        discount: couponData.discount || '',
        amount: couponData.amount || '',
        couponNum: data.totalNum,
        limitAmount: couponData.limitAmount
      }
      this.infoForm = infoObj

      const undertaker = {
        underArray: JSON.parse(data.cost)
      }
      this.undertakerForm = undertaker

      const limitObj = JSON.parse(data.limitTimeData)
      const useLimitObj = {
        deductionType: data.limitType,
        amount: data.limitPrice,
        useTime: data.limitTime,
        relativeTime: data.limitTime === 1 ? data.limitTimeData : '',
        useDate: data.limitTime === 1 ? [] : [limitObj.startTime, limitObj.endTime],
        useExplain: data.detail,
        partakeStation: data.useType,
        operator: data.useType === 1 ? data.useData.split(',') : [],
        station: data.useType === 2 ? data.useData.split(',') : []
      }
      this.useLimitForm = useLimitObj
      this.stationName = data.useDataName
    },
    // 加载全部运营商和电站数据
    loadTree() {
      const data1 = {
        treeDepth: 'ORG'
      }
      const data2 = {
        treeDepth: 'STATION'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data1,
        callback: resp => {
          this.operatorTreeData = resp
        }
      })
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data2,
        callback: resp => {
          this.stationTreeData = resp
        }
      })
    },
    // 加载承担方数据
    loadUndertaker() {
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.$store.dispatch('form/handle', {
        url: '/org/page',
        data: data,
        callback: resp => {
          console.log('请求到的承担方数据：', resp)
          this.allUndertaker = resp.list
          this.pageNo = resp.pageNo
          this.pageSize = resp.pageSize
        }
      })
    },
    numberfilter(num) {
      return numberfilter(num)
    },
    /**
     * el-select上滑到最后一个后启动加载
     */
    selectLoadMore() {
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.$store.dispatch('form/handle', {
        url: '/org/page',
        data: data,
        callback: resp => {
          console.log('请求到的承担方数据：', resp)
          this.allUndertaker.push(...resp.list)
          this.pageNo = resp.pageNo
          this.pageSize = resp.pageSize
        }
      })
    },
    /**
     * 表单添加一行优惠券
     */
    addUndertaker(index) {
      const data = {
        id: '',
        percent: '',
        index: '',
        name: ''
      }
      this.undertakerForm.underArray.splice(index + 1, 0, data)
    },
    /**
     * 删除删除一行优惠券
     */
    delUndertaker(index) {
      this.undertakerForm.underArray.splice(index, 1)
    },
    onSubmit() {
      let infoFormBool = false
      this.$refs['infoForm'].validate(valid => {
        infoFormBool = valid
      })
      let undertakerFormBool = false
      this.$refs['undertakerForm'].validate(valid => {
        undertakerFormBool = valid
      })
      let useLimitFormBool = false
      this.$refs['useLimitForm'].validate(valid => {
        useLimitFormBool = valid
      })
      // 如果两个表单都验证正确
      if (infoFormBool && undertakerFormBool && useLimitFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    // 承担方选中的change方法
    selectData(value, index) {
      const name = this.allUndertaker[value].name
      const id = this.allUndertaker[value].id
      this.undertakerForm.underArray[index].name = name
      this.undertakerForm.underArray[index].id = id
    },
    submitData() {
      // 选择可用电站后返回的树
      const options = {
        '-1': () => {
          return ['-1', '-1']
        },
        '1': () => {
          // 获取树所有已选择的数据
          const treeArray = this.$refs.treeOperator.getCheckedNodes()
          // 获取所有的id 字符串 以逗号分割
          const id = treeArray.map(item => item.id).join(',')
          // 获取所有的名字 字符串 以逗号分割
          const name = treeArray.map(item => item.name).join(',')
          return [id, name]
        },
        '2': () => {
          // 获取树所有已选择的数据
          const treeArray = this.$refs.treeStation.getCheckedNodes()
          // 获取所有的id 字符串 以逗号分割
          const id = treeArray.map(item => item.id).join(',')
          // 获取所有的名字 字符串 以逗号分割
          const name = treeArray.map(item => item.name).join(',')
          return [id, name]
        }
      }

      // 选择优惠券类型后的字段 1：现金券->优惠券面额 2：折扣券->优惠券折扣、折扣抵扣上限
      const couponData = this.infoForm.type === 1 ? JSON.stringify({ amount: this.infoForm.amount }) : JSON.stringify({ limitAmount: this.infoForm.limitAmount, discount: this.infoForm.discount })
      const data = {
        cost: JSON.stringify(this.undertakerForm.underArray), // 承担方
        couponData: couponData,
        couponName: this.infoForm.couponName, // 优惠券名称
        detail: this.useLimitForm.useExplain, // 优惠券描述
        limitPrice: this.useLimitForm.amount, // 服务费-电费-总费用
        limitTime: this.useLimitForm.useTime, // 使用时间 1是相对时间 2是绝对时间
        // 如果是相对时间，直接传 如果是绝对时间，传json格式
        limitTimeData: this.useLimitForm.useTime === 1 ? this.useLimitForm.relativeTime : JSON.stringify({ startTime: this.useLimitForm.useDate[0], endTime: this.useLimitForm.useDate[1] }),
        limitType: this.useLimitForm.deductionType, // 抵扣费用类型
        totalNum: this.infoForm.couponNum, // 优惠券数量
        type: this.infoForm.type, // 优惠券类型 1满减 2折扣
        useType: this.useLimitForm.partakeStation, // 可用电站
        useData: options[this.useLimitForm.partakeStation]()[0], // 可用电站下面的树的id
        useDataName: options[this.useLimitForm.partakeStation]()[1], // 可用电站下面的树的name
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/add',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    // 树的节点筛选
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .d-flex{
    display: flex;
  }
  .jc-sb{
    justify-content: space-between;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .mt-25{
    margin-top: 25px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .amount{
    /deep/.el-input{
      width: 70%;
      padding: 0 10px;
    }
  }
  .w30{
    width: 30%;
  }
  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .detail{
    /deep/.el-input__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-textarea__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-input{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-separator{
      color: #606266 !important;
    }
    /deep/.el-range__icon{
      color: #606266 !important;
    }
  }
  //去除input的type为number时的上下箭头

  /deep/input::-webkit-outer-spin-button,
  /deep/input::-webkit-inner-spin-button { -webkit-appearance: none; }
  /deep/input[type="number"]{ -moz-appearance: textfield; }
</style>



// WEBPACK FOOTER //
// src/views/discount/couponDetail.vue